import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as vinWonderActions from '../../../../actions/vinWonderAction';
import VinWonderCheck from './VinWonderCheck';

const mapStateToProps = state => {
    return {
        vinWonders: state.vinWonderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCheckVinWonder: (serialNumber) => {
            dispatch(vinWonderActions.checkVinWonderAction(serialNumber))
        },
        onResetCheck: () => {
            dispatch(vinWonderActions.vinWonderReset())
        },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VinWonderCheck));
